interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  align?: 'left' | 'center';
  tone?: 'light' | 'dark';
  className?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  subtitle,
  align = 'center',
  tone = 'light',
  className = '',
}: SectionHeadingProps) {
  const isDark = tone === 'dark';
  const alignment = align === 'center' ? 'items-center text-center mx-auto' : 'items-start text-left';

  return (
    <div className={`flex flex-col ${alignment} ${className}`}>
      {eyebrow ? (
        <span
          className={`inline-flex items-center gap-2 rounded-full px-3.5 py-1.5 text-[11px] font-semibold uppercase tracking-[0.16em] ${
            isDark
              ? 'bg-background-50/10 text-accent-300'
              : 'bg-accent-100 text-accent-900'
          }`}
        >
          <span className="w-1.5 h-1.5 rounded-full bg-accent-500" aria-hidden="true"></span>
          {eyebrow}
        </span>
      ) : null}
      <h2
        className={`mt-4 font-heading text-2xl md:text-4xl font-bold text-balance ${
          isDark ? 'text-background-50' : 'text-foreground-950'
        }`}
      >
        {title}
      </h2>
      {subtitle ? (
        <p
          className={`mt-4 text-sm md:text-base leading-relaxed max-w-2xl ${
            isDark ? 'text-background-200/85' : 'text-foreground-600'
          }`}
        >
          {subtitle}
        </p>
      ) : null}
    </div>
  );
}